import * as config from "../config.json";
import {getJwt} from "./session";


function call(operation, method, body) {
  const jwt = getJwt();
  return fetch(`${config.apiEndpoint}/${operation}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${jwt}`
    },
    body: JSON.stringify(body, (k, v) => (v === undefined && method === 'PATCH') ? null : v)
  });
}

async function callJson(operation, method = 'GET', body) {
  return call(operation, method, body).then(r => r.json());
}

export async function me() {
  return callJson('me')
    .catch((e) => {
      console.error(e);
      return false;
    });
}

export async function list(table, filter = {}, sort = {}, populate = []) {
  return callJson(`data/${table}?filter=${encodeURIComponent(JSON.stringify(filter))}&sort=${encodeURIComponent(JSON.stringify(sort))}&populate=${encodeURIComponent(JSON.stringify(populate))}`);
}

export async function listTables() {
  return callJson(`schema/`);
}

export async function schema(table) {
  return callJson(`schema/${table}`);
}

export async function createRecord(table, record) {
  return callJson(`data/${table}`, 'POST', record);
}

export async function updateRecord(table, recordId, fields) {
  return callJson(`data/${table}/${recordId}`, 'PATCH', fields);
}

export async function removeRecord(table, recordId) {
  return callJson(`data/${table}/${recordId}`, 'DELETE');
}

export async function getHtmlInvoice(year, month, customer) {
  return call(`invoicing/html?year=${year}&month=${month}&customer=${customer}`).then(r => r.text());
}

export async function getHtmlInvoiceById(id) {
  return call(`invoicing/html?id=${id}`).then(r => r.text());
}

export async function getInvoice(year, month, customer) {
  return callJson(`invoicing/invoice?year=${year}&month=${month}&customer=${customer}`);
}

export async function printInvoice(invoiceId) {
  return callJson(`invoicing/print?id=${invoiceId}`);
}

export async function getFile(id) {
  return callJson(`data/files/${id}`);
}

export async function getStats() {
  return callJson(`invoicing/stats`);
}
